import Vue from 'vue'
import service from '../services/vendors-service'

export function useVendors() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getVendors(params = {}) {
    state.loading = true
    try {
      const response = await service.getVendors(params)
      response.vendors.data = response.vendors.data.map(vendor => {
        return {
          ...vendor,
          rps_active: vendor.rps_active === '1' ? true : false,
          rps_blacklist: vendor.rps_blacklist === '1' ? true : false
        }
      })
      state.items = response.vendors.current_page === 1
        ? [...response.vendors.data]
        : [...state.items, ...response.vendors.data]
      state.currentPage = response.vendors.current_page
      state.lastPage = response.vendors.last_page
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function updateVendor(payload) {
      state.loading = true
      try {
        const response = await service.updateVendor(payload)
        const vendorIndex = state.items.findIndex(el => el.VendorId === payload.vendorId)
        if (vendorIndex !== -1) {
          state.items[vendorIndex][payload.column] = payload.value
        }
        return { success: true, response }
      } catch (err) {
        return { success: false, error: err }
      } finally {
        state.loading = false
      }
    }

  return { state, getVendors,updateVendor }
}
